var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.384 4.136C15.044 2.79866 16.952 2.79866 17.612 4.136L20.756 10.5067L27.7867 11.528C29.2627 11.7413 29.852 13.5573 28.784 14.5987L23.696 19.5573L24.8973 26.5573C25.1507 28.0293 23.6067 29.1507 22.2853 28.456L15.9973 25.1493L9.71067 28.456C8.39067 29.1493 6.84667 28.0293 7.09733 26.5587L8.29867 19.5573L3.212 14.5973C2.144 13.5573 2.73333 11.7427 4.20933 11.528L11.24 10.5067L14.384 4.136Z",
    fill: "#F89616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStars);
export default __webpack_public_path__ + "static/media/ic-stars.f98f684485394f2d60728db28ca378c1.svg";
export { ForwardRef as ReactComponent };